// by using universal-cookie, you can expect that this code will only work
// client-side. to make it work server-side, have your component pass the
// cookies object provided to it by the `withCookies` HOC.
import Cookies from "universal-cookie";
import { COOKIES } from "rtr-constants";
/**
 * This calls a next-auth route /api/auth/signout to clean the next-auth.session-token cookie
 * @returns {Promise<*>}
 * @see {https://next-auth.js.org/getting-started/client#signout}
 */
export async function cleanSession() {
  const cookies = new Cookies();
  // Clear RTR_LOGGED_IN cookie so that even if signout fails in NextAuth (due to absence of valid CAS authn cookies) the user doesn't get trapped in a refresh attempt loop
  cookies.remove(COOKIES.RTR_LOGGED_IN, { path: "/" });
  // Using a dynamic import for now because next-auth seems to try to use 'process.env'
  // browser-side when the Cypress tests run and load next-auth/react?
  // Not sure why.
  const { signOut } = await import("next-auth/react");
  return signOut();
}

/**
 * This will navigate the user to the SF Provider sign in page, and then return them to where they were after successful sign in.
 * @param {object} [options] options to be passed to NextAuth signIn
 * @returns {Promise<*>}
 * @see {https://next-auth.js.org/getting-started/client#signin}
 */
export async function signIn(options = {}) {
  // Using a dynamic import for now because next-auth seems to try to use 'process.env'
  // browser-side when the Cypress tests run and load next-auth/react?
  // Not sure why.
  const { signIn } = await import("next-auth/react");
  return signIn("storefront", options);
}
